import { createRemoteReducer, RemoteReducer } from "types/Remote"

export const exampleNewsletterReducer: RemoteReducer<string> =
  createRemoteReducer("exampleNewsletter")
